import { Component, OnInit } from '@angular/core';

import { CopyService } from '../../../shared/services/copies/copy.service';
import { HeaderService } from '../../../shared/services/header/header.service';
import { NavigationService } from '../../../shared/services/navigation/navigation-onboarding.service';
import { AbreCuentasService } from '../../../shared/services/abre-cuentas/abre-cuentas.service';
import { HelpersService } from '../../../shared/services/helpers/helpers-onboarding.service';
import { BioCatchService } from 'src/app/shared/services/external/biocatch/biocatch.service';
import { ProductsBiocatchEnum, StepBiocatchEnum } from 'src/app/shared/enums/biocatchContext.enum';
import { FirmlyApprovedService } from 'src/app/shared/services/firmly-approved/firmly-approved.service';
import { ChannelCommunicatorService } from 'src/app/shared/services/communicator/channel-communicator/channel-communicator.service';
import { DaliService, IPageLoadModel } from '@dali/tagger-ng8';
import {
  EVENT as EVENT_FA_LD,
  PAGEVIEW as PAGEVIEW_FA_LD,
  CHANNEL as CHANNEL_FA_LD,
  COUNTRY as COUNTRY_FA_LD,
  BUSINNESS as BUSINNESS_FA_LD,
  ENVIRONMENT as ENVIRONMENT_FA_LD,
  FAMILY as FAMILY_FA_LD,
  SUBFAMILY as SUBFAMILY_FA_LD,
  PRODUCT as PRODUCT_FA_LD,
} from 'src/app/shared/constants/dali-fa-ld.constants';
import { TaggingService } from 'src/app/shared/services/tagging/tagging.service';

@Component({
  selector: 'app-pay-day',
  templateUrl: './pay-day.component.html',
  styleUrls: ['./pay-day.component.scss'],
})
export class PayDayComponent implements OnInit {
  isBtnDisabled = true;
  minimumDate: any;
  maximumDate: any;
  showDatePicker = false;
  selectedDate: any;
  viewOptionMultiProduct = false;
  listDates: any = [];
  constructor(
    public copyService: CopyService,
    private headerService: HeaderService,
    private navigationService: NavigationService,
    private abreCuentasService: AbreCuentasService,
    private helperService: HelpersService,
    private bioCatchService: BioCatchService,
    private firmlyApprovedService: FirmlyApprovedService,
    private channelCommunicatorService: ChannelCommunicatorService,
    private daliService: DaliService,
    private taggingServices: TaggingService,
  ) {
    this.headerService.show(true, true, true);
    this.setDates();
  }

  ngOnInit() {
    this.sendTagging('init');
    if (this.taggingServices.isFirmlyAprovedMono()) {
      this.sendPayDayPageLoad();
    }

    if (!this.firmlyApprovedService.isEmpty() && this.firmlyApprovedService.getOfferType_Channel() === 'En_firme') {
      const product = this.abreCuentasService.getproductSelected().product_code as ProductsBiocatchEnum;
      this.bioCatchService.changeContext(StepBiocatchEnum.configuracion, product, false);
    }

    const currentDate = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Bogota' }));
    this.minimumDate = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Bogota' }));
    this.minimumDate = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Bogota' }));
    this.minimumDate = this.addMonths(this.minimumDate, 1);
    this.minimumDate = this.helperService.formatingVclDate(this.minimumDate);
    this.maximumDate = currentDate;
    this.maximumDate = this.addMonths(this.maximumDate, 2, true);
    this.maximumDate = this.helperService.formatingVclDate(this.maximumDate);
    this.showDatePicker = true;
    this.selectedDate = this.abreCuentasService.getPAyDay();
    this.viewOptionMultiProduct = this.abreCuentasService.viewOptionMultiProduct;
    this.enableContinue();
  }

  /**
   * Summary Go to next Step
   */
  next() {
    this.sendTagging('next', 'bottom', '2');
    if (this.taggingServices.isFirmlyAprovedMono()) {
      this.sendContinueButtonEvent();
    }
    const clientProduct = this.abreCuentasService.getClientProduct();
    console.log('Pay-day >>> clientProduct: ', clientProduct, '\n   this.abreCuentasService.getproductSelected(): ', this.abreCuentasService.getproductSelected());
    if (this.abreCuentasService.viewOptionMultiProduct) {
      if (!this.firmlyApprovedService.isEmpty() && this.firmlyApprovedService.getOfferType_Channel() === 'En_firme') {
        this.navigationNextValidation();
      } else {
        this.navigationService.nextStep(this.navigationService.nextMulti(this.abreCuentasService.getProductsSelects()));
      }
    } else {
      this.navigationNextValidation();
    }
  }

  private navigationNextValidation() {
    const clientProduct = this.abreCuentasService.getClientProduct();
    if (clientProduct) {
      this.navigationService.nextStep('201');
    } else {
      this.navigationService.nextStep('200');
    }
  }

  addMonths(date, months, last?) {
    const d = date.getDate();
    date.setMonth(date.getMonth() + +months);
    if (date.getDate() !== d) {
      date.setDate(0);
    } else if (last) {
      date.setDate(this.maximumDate.getDate() - 1);
    }
    return date;
  }

  enableContinue() {
    if (this.selectedDate) {
      this.abreCuentasService.setPayDay(this.selectedDate);
      this.isBtnDisabled = false;
    } else {
      this.selectedDate = null;
    }
  }

  /* ------------- Taggeo ------------- */

  /* ------------ Taggeo - PageLoad ------------ */
  sendPayDayPageLoad(): void {
    const isApp = this.channelCommunicatorService.getChannelId() === '141';
    const productsType = {
      ORD: 'LD',
      TCR: 'TC',
    };
    const changes: IPageLoadModel[] = [
      {
        path: PAGEVIEW_FA_LD.pv9pageName.path,
        value: `${isApp ? CHANNEL_FA_LD.superapp : CHANNEL_FA_LD.homeBanking}:${COUNTRY_FA_LD.co}:${BUSINNESS_FA_LD.pf}:${ENVIRONMENT_FA_LD.loggeado}:${FAMILY_FA_LD.services}:${SUBFAMILY_FA_LD.request}:${PRODUCT_FA_LD.request}:${PAGEVIEW_FA_LD.pv9pageName.value}`,
      },
      {
        path: PAGEVIEW_FA_LD.pv9pageFamily.path,
        value: PAGEVIEW_FA_LD.pv9pageFamily.value,
      },
      {
        path: PAGEVIEW_FA_LD.pv9subFamily.path,
        value: PAGEVIEW_FA_LD.pv9subFamily.value,
      },
      {
        path: PAGEVIEW_FA_LD.pv9pageAction.path,
        value: PAGEVIEW_FA_LD.pv9pageAction.value,
      },
      {
        path: PAGEVIEW_FA_LD.pv9pageid.path,
        value: PayDayComponent.name,
      },
      {
        path: PAGEVIEW_FA_LD.pv9transactionName.path,
        value: `${PAGEVIEW_FA_LD.pv9transactionName.value.slice(0, -2)}${this.taggingServices.getProductFlow()}`,
      },
      {
        path: PAGEVIEW_FA_LD.pv9transactionTransactionStep.path,
        value: PAGEVIEW_FA_LD.pv9transactionTransactionStep.value,
      },
    ];
    this.taggingServices.addCommonPageChanges(changes);
    this.daliService.pageLoad(changes);
  }

  /* -------------- Taggeo - Events ------------- */

  sendBackButtonEvent(): void {
    this.sendTagging('prev', 'bottom', '1');
    if (!this.taggingServices.isFirmlyAprovedMono()) {
      return;
    }
    const data = [
      {
        path: EVENT_FA_LD.pv9E1setData.pv9E1transactionTransactionStep.path,
        value: EVENT_FA_LD.pv9E1setData.pv9E1transactionTransactionStep.value,
      },
      {
        path: EVENT_FA_LD.pv9E1setData.pv9E1transactionName.path,
        value: EVENT_FA_LD.pv9E1setData.pv9E1transactionName.value,
      },
    ];
    const event = {
      category: {
        module: EVENT_FA_LD.customCategory.module.body,
        type: EVENT_FA_LD.customCategory.type.button,
        position: EVENT_FA_LD.customCategory.position.bottom,
      },
      action: EVENT_FA_LD.customAction.click,
      label: EVENT_FA_LD.pv9E1customLabel,
    };
    this.daliService.trackEvent(event, data);
  }

  sendContinueButtonEvent(): void {
    const data = [
      {
        path: EVENT_FA_LD.pv9E2setData.pv9E2transactionTransactionStep.path,
        value: EVENT_FA_LD.pv9E2setData.pv9E2transactionTransactionStep.value,
      },
      {
        path: EVENT_FA_LD.pv9E2setData.pv9E2transactionName.path,
        value: EVENT_FA_LD.pv9E2setData.pv9E2transactionName.value,
      },
    ];
    const event = {
      category: {
        module: EVENT_FA_LD.customCategory.module.body,
        type: EVENT_FA_LD.customCategory.type.button,
        position: EVENT_FA_LD.customCategory.position.bottom,
      },
      action: EVENT_FA_LD.customAction.click,
      label: EVENT_FA_LD.pv9E2customLabel,
    };
    this.daliService.trackEvent(event, data);
  }

  sendTagging(value: any, position?: string, event?: string) {
    const page = '10';
    const extras = {
      pageValue: 'PayDayComponent',
    };
    this.taggingServices.sendTaggValues(value, page, position, event, extras);
  }

  getPayDate(dayInput: string): string {
    const date = new Date();
    const year = date.getFullYear();
    let month = (date.getMonth() + 1) + '';
    let day = dayInput;
    if (day.length < 2) {
      day = '0' + day;
    }
    if (month.length < 2) {
      month = '0' + month;
    }
    return day + '/' + month + '/' + year;
  }

  getFormatDay(day: string): string {
    if (day.length < 2) {
      day = '0' + day;
    }
    return day;
  }

  setDates(): void {
    const initialDay = this.copyService.copies.pay_day.initial_day;
    const finishDay = this.copyService.copies.pay_day.finish_day;
    for (let index = initialDay; index <= finishDay; index++) {
      const day = this.getFormatDay(index + '');
      const dayFormat = {
        day,
        dateFormat: this.getPayDate(day),
      };
      this.listDates.push(dayFormat);
    }
  }

  selectOption(event: any) {
    this.selectedDate = event.value;
    this.enableContinue();
  }
}
